<template lang="pug">
  #program-customization-login
    ProgramSettingsFormWrapper#general-settings(
      :form-data="formData"
      :disable-save.sync="disableSave"
      title=""
      disableReset
      :formControlIsText="false"
      :keys-to-reset="[]"
      :saveButtonText="saveButtonText"
    )
      ContentLoader(:width="300" :height="120" v-if="!programLoaded")
        rect(x="0", y="0", rx="4", ry="4", width="45%", height="100")
        rect(x="50%", y="0", rx="4", ry="4", width="50%", height="30")
        rect(x="50%", y="45", rx="4", ry="4", width="50%", height="30")
        rect(x="50%", y="90", rx="4", ry="4", width="50%", height="30")

      .columns(v-else)
        .column.is-12
          WtRadioQuestionInput.block(
            label="Customize the Member Login page"
            horizontal
          )
            template(v-slot:radioOne)
              BRadio.define-radio(
                v-model="customLoginPage"
                :native-value="true"
              )
                | Yes
            template(v-slot:radioTwo)
              BRadio.define-radio(
                v-model="customLoginPage"
                :native-value="false"
              )
                | No
          WtWysiwyg(:content.sync="customLoginPageContent")
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { ContentLoader } from "vue-content-loader";
import programSettingsFormMixin from "@/mixins/programSettingsFormMixin";
import ProgramSettingsFormWrapper from "@@/ProgramSettingsAdmin/ProgramSettingsFormWrapper";
import WtRadioQuestionInput from "@@/WtRadioQuestionInput/WtRadioQuestionInput";
import WtWysiwyg from "@@/WtWysiwyg/WtWysiwyg";

export default {
  name: "ProgramCustomizationLogin",

  components: {
    ProgramSettingsFormWrapper,
    ContentLoader,
    WtRadioQuestionInput,
    WtWysiwyg
  },

  mixins: [programSettingsFormMixin],

  data() {
    return {
      newLogo: null
    };
  },

  computed: {
    ...mapGetters("program", [
      "coreProgramMeta",
      "programSettingsCopy",
      "programLoaded"
    ]),

    formData() {
      const data = {};
      if (!this.isOriginalValue("customLoginPage", this.customLoginPage)) {
        data.customLoginPage = this.customLoginPage;
      }
      if (
        !this.isOriginalValue(
          "customLoginPageContent",
          this.customLoginPageContent
        )
      ) {
        data.customLoginPageContent = this.customLoginPageContent;
      }

      return data || {};
    },

    customLoginPage: {
      set(val) {
        this.updateProgramSettingsCopy({ key: "customLoginPage", value: val });
        this.disableSave =
          this.isOriginalValue("customLoginPage", this.customLoginPage) ||
          !this.customLoginPageContent;
      },
      get() {
        return this.programSettingsCopy.customLoginPage;
      }
    },

    customLoginPageContent: {
      set(val) {
        this.updateProgramSettingsCopy({
          key: "customLoginPageContent",
          value: val
        });
        this.disableSave = this.isOriginalValue(
          "customLoginPageContent",
          this.customLoginPageContent
        );
      },
      get() {
        return this.programSettingsCopy.customLoginPageContent;
      }
    },

    saveButtonText() {
      if (this.coreProgramMeta.customLoginPageContent) {
        return "Update";
      }
      return "Save";
    }
  },

  watch: {},

  mounted() {},

  methods: {
    ...mapActions("program", [
      "updateCoreMeta",
      "updateProgramSettingsCopy",
      "programSettingsUpdate"
    ]),

    ...mapActions(["snackBar"])
  }
};
</script>

<style lang="sass">
#program-customization-login
</style>
